import React from "react";
import { Segment } from "semantic-ui-react";
import { Menu, Icon, Button } from "antd";
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBCollapse
} from "mdbreact";
import { Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "antd/dist/antd.css";
import "../sidemenu.css";
import "../report.css";
import ChartsPage from "./Dashboard";
import Donut from "./small_chart";
import ViewForm from "./ViewForm";
import Profile from "./profile.js";
import MigrationData from "./MigrationData.js";
import JobDetails from "./JobDetails.js";
import Contact from "./contact.js";
import Group from "./group.js";
import BulkSMS from "./bulksms.js";
import Request from "./request.js";
import { reactLocalStorage } from "reactjs-localstorage";
import "react-notifications-component/dist/theme.css";
import "semantic-ui-css/semantic.min.css";
import { Dropdown } from "semantic-ui-react";
import { Header } from "semantic-ui-react";
import Modal from "react-modal";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import i18n from "../i18n";
import { connect } from "react-redux";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};

class MenuSideWeb extends React.Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false,
      show: false,
      collapsed: false,
      collapseID: ""
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = "#f00";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  state = { activeIndex: 0 };
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  componentDidMount() {
    reactLocalStorage.get("authenticated");
    reactLocalStorage.get("accessToken");
    this.setState({ modalIsOpen: true });
    var lang = i18n.language;
    if (lang === "ar") {
      document.querySelector(".main_div_loading").style = "direction:rtl";
      document.querySelector(".menu_header").style = "margin-right:14%";
      document.querySelector(".ant-menu").style = "text-align:right";
      document.querySelector(".text_style").style =
        "text-align:right;width: 20%;margin-right: 14%";
    }

    /*  if(reactLocalStorage.get('authenticated') === 'false' )
  {
    document.querySelector('.main_div_loading').style = 'display:none';
    window.location="/app";
  }
  else
  {
  document.querySelector('.main_div_loading').style = 'display:block';
  }

*/
  }

  toggleCollapse = collapseID => () => {
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));
  };

  toggleCollapsed = () => {
    this.setState({ collapsed: !this.state.collapsed });

    if (this.state.collapsed) {
      document.querySelector(".actionMenu").style = "width:84.5%";
      document.querySelector(".menuWeb").style =
        "width:15.5%;opacity:1;display:block;";
      document.querySelector(".logo_header").style =
        "display:inline-block !important";
      document.querySelector(".header_logo_web").style = "width: 13em;";
      document.querySelector(".bar_chart").style = "zoom:1.5 !important";
      document.querySelector(".user_add").style = "zoom:1.5 !important";
      document.querySelector(".phone").style = "zoom:1.5 !important";
      document.querySelector(".group").style = "zoom:1.5 !important";
      document.querySelector(".sms").style = "zoom:1.5 !important";
      document.querySelector(".request").style = "zoom:1.5 !important";
      document.querySelector(".menu_header").style =
        "margin-left: 8%;margin-top: 0.552857em !important;width:16% !important";
    } else {
      document.querySelector(".actionMenu").style = "width:94.5%";
      document.querySelector(".menuWeb").style = "width:5.5%;";
      document.querySelector(".logo_header").style = "display:none !important";
      document.querySelector(".header_logo_web").style = "width:4.5em";
      document.querySelector(".menu_header").style =
        "margin-top: 15% !important;width:48% !important;margin-left: 30% !important";
    }
  };

  menuToggleDashboard = () => {
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Dashboard_hidden").style = "display:block";
    document.querySelector(".Profile_hidden").style = "display:none";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".Group_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };

  menuToggleReports = () => {
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:none";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".Group_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };

  Addsubadmin = () => {
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:none";
    document.querySelector(".add_form").style = "display:none";
    //document.querySelector(".form_edit_hidden").style = "display:none";

    document.querySelector(".Adds_hidden").style = "display:block";

    document.querySelector(".main_div_contractor").style = "display:block";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".Group_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };

  Profile = () => {
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:block";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".Group_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };

  MigrationData = () => {
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:block";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".Group_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };

  JobDetails = () => {
  document.querySelector(".Dashboard_hidden").style = "display:none";
  document.querySelector(".Adds_hidden").style = "display:none";
  document.querySelector(".Profile_hidden").style = "display:block";
  document.querySelector(".Contact_hidden").style = "display:none";
  document.querySelector(".Group_hidden").style = "display:none";
  document.querySelector(".BulkSMS_hidden").style = "display:none";
  document.querySelector(".Request_hidden").style = "display:none";
};
  Contact = () => {
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:none";
    document.querySelector(".Contact_hidden").style = "display:block";
    document.querySelector(".Group_hidden").style = "display:none";

    document.querySelector(".main_div_contact").style = "display:block";
    document.querySelector(".main_contact").style = "display:block";
    document.querySelector(".add_form").style = "display:none";
    document.querySelector(".import_hidden_contact").style = "display:none";
    document.querySelector(".form_contact_edit_hidden_contact").style =
      "display:none";
    document.querySelector(".form_hidden_contact").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };

  Group = () => {
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:none";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Group_hidden").style = "display:block";
    document.querySelector(".main_div_category").style = "display:block";
    document.querySelector(".category_main").style = "display:block";
    document.querySelector(".form_category_hidden").style = "display:none";
    document.querySelector(".form_category_edit_hidden").style = "display:none";
    document.querySelector(".form_group_hidden").style = "display:none";
    document.querySelector(".form_group_edit_hidden").style = "display:none";
    document.querySelector(".add_form").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };

  BulkSMS = () => {
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:none";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:block";
    document.querySelector(".Group_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:none";
  };
  Request = () => {
    document.querySelector(".Dashboard_hidden").style = "display:none";
    document.querySelector(".Adds_hidden").style = "display:none";
    document.querySelector(".Profile_hidden").style = "display:none";
    document.querySelector(".Contact_hidden").style = "display:none";
    document.querySelector(".BulkSMS_hidden").style = "display:none";
    document.querySelector(".Group_hidden").style = "display:none";
    document.querySelector(".Request_hidden").style = "display:block";
    document.querySelector(".main_div_request").style = "display:block";
    document.querySelector(".main_request").style = "display:block";
    document.querySelector(".add_form").style = "display:none";
    document.querySelector(".form_hidden_request").style = "display:none";
  };

  ViewSMS = () => {
    if (this.state.show === false) {
      document.querySelector(".bulk_type").style = "display:block";
      document.querySelector(".profiled_type").style = "display:block";
      document.querySelector(".lba_type").style = "display:block";
      document.querySelector(".survey_type").style = "display:block";
      document.querySelector(".international_type").style = "display:block";
      this.setState({ show: true });
    }
    if (this.state.show === true) {
      document.querySelector(".bulk_type").style = "display:none";
      document.querySelector(".profiled_type").style = "display:none";
      document.querySelector(".lba_type").style = "display:none";
      document.querySelector(".survey_type").style = "display:none";
      document.querySelector(".international_type").style = "display:none";
      this.setState({ show: false });
    }
  };

  ViewSMSMobile = () => {
    if (this.state.show === false) {
      document.querySelector(".bulk_type_mobile").style = "display:block";
      document.querySelector(".profiled_type_mobile").style = "display:block";
      document.querySelector(".lba_type_mobile").style = "display:block";
      document.querySelector(".survey_type_mobile").style = "display:block";
      document.querySelector(".international_type_mobile").style =
        "display:block";
      this.setState({ show: true });
    }
    if (this.state.show === true) {
      document.querySelector(".bulk_type_mobile").style = "display:none";
      document.querySelector(".profiled_type_mobile").style = "display:none";
      document.querySelector(".lba_type_mobile").style = "display:none";
      document.querySelector(".survey_type_mobile").style = "display:none";
      document.querySelector(".international_type_mobile").style =
        "display:none";
      this.setState({ show: false });
    }
  };
  viewAds = () => {};
  render() {
    const { activeIndex } = this.state;

    return (
      <div className="main_div_loading">
        <div className="menu_mobile_hidden">
          <MDBNavbar color="green lighten-4" light>
            <div
              style={{
                display: "inline-flex",
                width: " 100%",
                borderBottom: "1px solid rgb(178, 37, 173)"
              }}
            >
              <div style={{ width: " 50%" }}>
                <img
                  src={require("../pictures/zainlogoblac.png")}
                  className="logo_header_mobile"
                  alt="logo"
                  onClick={this.openModal}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div style={{ width: " 50%" }}>
                <img
                  src={require("../pictures/applications.png")}
                  className="menu_mobile"
                  alt="menu"
                  onClick={this.toggleCollapse("navbarCollapse13")}
                />
              </div>
            </div>

            <MDBCollapse
              id="navbarCollapse13"
              isOpen={this.state.collapseID}
              navbar
            >
              <MDBNavbarNav left>
                <MDBNavItem active onClick={this.menuToggleDashboard}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Dashboard.label")}
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem active onClick={this.Profile}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Profile.label")}
                  </MDBNavLink>
                </MDBNavItem>


                {/*................................New in 10-Jan-2025................................*/}
                <MDBNavItem active onClick={this.MigrationData}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                   Migration Data
                  </MDBNavLink>
                </MDBNavItem>
                {/* ................................End New in 10-Jan-2025...........................*/}

                 {/*................................New in 10-Jan-2025................................*/}
                 <MDBNavItem active onClick={this.JobDetails}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                   Job Details
                  </MDBNavLink>
                </MDBNavItem>
                {/* ................................End New in 10-Jan-2025...........................*/}

                <MDBNavItem active onClick={this.ViewSMSMobile}>
                  <MDBNavLink to="#!">{i18n.t("SMS.label")}</MDBNavLink>
                </MDBNavItem>
                <MDBNavItem
                  active
                  onClick={this.BulkSMS}
                  className="bulk_type_mobile"
                  style={{ display: "none" }}
                >
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    Bulk SMS 
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem
                  active
                  onClick={this.ProfiledSMS}
                  className="profiled_type_mobile"
                  style={{ display: "none" }}
                >
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    Profiled SMS
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem
                  active
                  onClick={this.LbaSMS}
                  className="lba_type_mobile"
                  style={{ display: "none" }}
                >
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    LBA SMS
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem
                  active
                  onClick={this.SurveySMS}
                  className="survey_type_mobile"
                  style={{ display: "none" }}
                >
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    Survey SMS
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem
                  active
                  onClick={this.InternationalSMS}
                  className="international_type_mobile"
                  style={{ display: "none" }}
                >
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    International SMS
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem onClick={this.Addsubadmin}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Create_Sub_Admin.label")}
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem onClick={this.Request} style={{ display: "none" }}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Requests.label")}
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem onClick={this.Group}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Groups.label")}
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem onClick={this.Contact}>
                  <MDBNavLink
                    to="#!"
                    onClick={this.toggleCollapse("navbarCollapse13")}
                  >
                    {i18n.t("Contact.label")}
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBNavLink to="/app">{i18n.t("Logout.label")}</MDBNavLink>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBNavbar>
        </div>

        <div className="menu_web">
          <div className="menuWeb">
            <Header floated="left" className="header_logo_web">
              <img
                src={require("../pictures/zainlogoblac.png")}
                className="logo_header"
                alt="logo"
                onClick={this.openModal}
                style={{ cursor: "pointer" }}
              />
              <img
                src={require("../pictures/applications.png")}
                className="menu_header"
                alt="menu"
                onClick={this.toggleCollapsed}
              />
            </Header>

            <Menu
              defaultSelectedKeys={["1"]}
              mode="inline"
              theme="dark"
              inlineCollapsed={this.state.collapsed}
            >
              <Menu.Item key="1" onClick={this.menuToggleDashboard}>
                <Icon type="dashboard" className="bar_chart" />
                <span className="emptyMenu">{i18n.t("Dashboard.label")}</span>
              </Menu.Item>

              <Menu.Item key="8" onClick={this.Profile}>
                <Icon type="profile" className="user_profile" />
                <span className="emptyMenu">{i18n.t("Profile.label")}</span>
              </Menu.Item>
            
                {/*................................New in 10-Jan-2025................................*/}
                <Menu.Item key="0101" onClick={this.MigrationData}>
                <Icon type="migration" className="user_migration" />
                <span className="emptyMenu">Migration Data</span>
              </Menu.Item>
                {/* ................................End New in 10-Jan-2025...........................*/}

                {/*................................New in 10-Jan-2025................................*/}
                <Menu.Item key="0101" onClick={this.JobDetails}>
                <Icon type="migration" className="user_migration" />
                <span className="emptyMenu">Job Details</span>
              </Menu.Item>
                {/* ................................End New in 10-Jan-2025...........................*/}
              <Menu.Item key="11" onClick={this.ViewSMS}>
                <Icon type="mail" className="sms" />
                <span className="emptyMenu">{i18n.t("SMS.label")}</span>
                <Dropdown>
                  <Dropdown.Menu />
                </Dropdown>
              </Menu.Item>

              <Menu.Item
                key="111"
                onClick={this.BulkSMS}
                className="bulk_type"
                style={{ display: "none" }}
              >
                <Icon type="mail" className="sms_sub" />
                <span className="emptyMenu">BulkSMS</span>
              </Menu.Item>
              <Menu.Item
                key="121"
                onClick={this.ProfiledSMS}
                className="profiled_type"
                style={{ display: "none" }}
              >
                <Icon type="mail" className="sms_sub" />
                <span className="emptyMenu">Profiled SMS</span>
              </Menu.Item>
              <Menu.Item
                key="131"
                onClick={this.LbaSMS}
                className="lba_type"
                style={{ display: "none" }}
              >
                <Icon type="mail" className="sms_sub" />
                <span className="emptyMenu">LBA SMS</span>
              </Menu.Item>

              <Menu.Item
                key="1233"
                onClick={this.SurveySMS}
                className="survey_type"
                style={{ display: "none" }}
              >
                <Icon type="mail" className="sms_sub" />
                <span className="emptyMenu">Survay SMS</span>
              </Menu.Item>

              <Menu.Item
                key="34"
                onClick={this.InternationailSMS}
                className="international_type"
                style={{ display: "none" }}
              >
                <Icon type="mail" className="sms_sub" />
                <span className="emptyMenu">International SMS</span>
              </Menu.Item>

              <Menu.Item key="3" onClick={this.Addsubadmin}>
                <Icon type="user-add" className="user_add" />
                <span className="emptyMenu">
                  {i18n.t("Create_Sub_Admin.label")}
                </span>
              </Menu.Item>

              <Menu.Item
                key="113"
                onClick={this.Request}
                style={{ display: "none" }}
              >
                <Icon type="bars" className="request" />
                <span className="emptyMenu">{i18n.t("Requests.label")}</span>
              </Menu.Item>

              <Menu.Item key="310" onClick={this.Group}>
                <Icon type="usergroup-add" className="group" />
                <span className="emptyMenu">{i18n.t("Groups.label")}</span>
              </Menu.Item>

              <Menu.Item key="4" onClick={this.Contact}>
                <Icon type="phone" className="phone" />
                <span className="emptyMenu">{i18n.t("Contact.label")}</span>
              </Menu.Item>

              <Menu.Item key="7">
                <Link to="/app">
                  {" "}
                  <Icon type="logout" className="logout_icon" />
                  <span className="emptyMenu">{i18n.t("Logout.label")}</span>
                </Link>
              </Menu.Item>
            </Menu>
          </div>

          <div className="actionMenu">
            <div className="contentActionMenu">
              <div className="Dashboard_hidden">
                <div className="main_div">
                  <Grid columns={2} divided>
                    <Grid.Row stretched>
                      <Grid.Column className="grid_logo">
                        <Segment>
                          <h3 className="text_style mof_color">
                            {i18n.t("Dashboard.label")}
                          </h3>
                        </Segment>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  <hr />
                  <div className="balance_details">
                    <Grid relaxed columns={5}>
                      <Grid.Column className="details">
                        <p className="bulk_details">Bulk SMS</p>
                        <p className="test">Remaining Balance:100</p>
                        <p className="test">Expiry Date:10/01/2020</p>
                      </Grid.Column>
                      <Grid.Column className="details_2">
                        <p className="profiled_details">Profiled SMS</p>
                        <p style={{ textAlign: "center" }} className="test">
                          Remaining Balance:100
                        </p>
                        <p style={{ textAlign: "center" }} className="test">
                          Expiry Date:10/01/2020
                        </p>
                      </Grid.Column>
                      <Grid.Column className="details_3">
                        <p className="lba_details">LBA SMS</p>
                        <p style={{ textAlign: "center" }} className="test">
                          Remaining Balance:100
                        </p>
                        <p style={{ textAlign: "center" }} className="test">
                          Expiry Date:10/01/2020
                        </p>
                      </Grid.Column>
                      <Grid.Column className="details_4">
                        <p className="survey_details">Survey SMS</p>
                        <p style={{ textAlign: "center" }} className="test">
                          Remaining Balance:100
                        </p>
                        <p style={{ textAlign: "center" }} className="test">
                          Expiry Date:10/01/2020
                        </p>
                      </Grid.Column>
                      <Grid.Column className="details_5">
                        <p className="international_details">
                          International SMS
                        </p>
                        <p style={{ textAlign: "center" }} className="test">
                          Remaining Balance:100
                        </p>
                        <p style={{ textAlign: "center" }} className="test">
                          Expiry Date:10/01/2020
                        </p>
                      </Grid.Column>
                    </Grid>
                  </div>
                  <div className="dount_div">
                    <Donut />
                    <Donut />
                    <Donut />
                  </div>
                  <ChartsPage />
                </div>
              </div>

              <div className="Adds_hidden" style={{ display: "none" }}>
                <ViewForm />
              </div>

              <div className="Group_hidden" style={{ display: "none" }}>
                <Group />
              </div>

              <div className="Profile_hidden" style={{ display: "none" }}>
                <Profile />
              </div>
 {/*................................New in 10-Jan-2025...............................*/}
              <div className="Profile_hidden" style={{ display: "none" }}>
                <MigrationData />
              </div>
 {/*............................End New in 10-Jan-2025................................*/}
  {/*................................New in 10-Jan-2025...............................*/}
  <div className="Profile_hidden" style={{ display: "none" }}>
                <JobDetails />
              </div>
 {/*............................End New in 10-Jan-2025................................*/}
              <div className="Request_hidden" style={{ display: "none" }}>
                <Request />
              </div>

              <div className="BulkSMS_hidden" style={{ display: "none" }}>
                <BulkSMS />
              </div>

              <div className="Contact_hidden" style={{ display: "none" }}>
                <Contact />
              </div>

              <div className="modal_ads">
                <Modal
                  isOpen={this.state.modalIsOpen}
                  onAfterOpen={this.afterOpenModal}
                  onRequestClose={this.closeModal}
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <h2 ref={subtitle => (this.subtitle = subtitle)} />
                  <br />
                  <div className="slider_auth">
                    <div>
                      <Carousel
                        style={{ width: "20%" }}
                        arrowLeft={
                          <Icon
                            className="icon-example"
                            type="left-circle"
                            style={{ zoom: "2", padding: "3px" }}
                          />
                        }
                        arrowRight={
                          <Icon
                            className="icon-example"
                            type="right-circle"
                            style={{ zoom: "2", padding: "3px" }}
                          />
                        }
                        addArrowClickHandler
                      >
                        <img
                          src={require("../pictures/slider.jpg")}
                          className="slider_pic"
                        />
                        <img
                          src={require("../pictures/slider2.jpg")}
                          className="slider_pic"
                        />
                        <img
                          src={require("../pictures/slider3.png")}
                          className="slider_pic"
                        />
                      </Carousel>
                    </div>
                  </div>
                  <Button onClick={this.closeModal} className="close_btn">
                    {i18n.t("Close.label")}
                  </Button>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return { ...state };
};
export default connect(mapStateToProps)(MenuSideWeb);
